import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/@services/common.service';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import { CommonPagesService } from '../../common-pages.service';
import {
  ActivityType,
  BrooklynBillStatus,
  BrooklynInvestmentStatus,
  PaybevInvestmentStatus,
  PaybevPaymentStatus,
  responseMessageStatus,
  ResponseStatus,
  TransactionsType,
} from '../../enum';
interface siteDetails {
  Name: string;
  Profile: string;
  NonAlcStatus: boolean;
  IsProgramPeriodVisible: boolean;
  IsTagVisible: boolean;
}
@Component({
  selector: 'app-managetransaction',
  templateUrl: './managetransaction.component.html',
  styleUrls: ['./managetransaction.component.scss'],
  standalone: false
})
export class ManagetransactionComponent implements OnInit {
  //#region properties
  isVisibleTransactionModal: boolean = true;
  @Output() hideTransactionModal = new EventEmitter();
  @Input() transactionType: number;
  @Input() transactionId: string;
  @Input() transactionDetails: any;
  brooklynBillStatus = BrooklynBillStatus;
  brooklynInvestmentStatus = BrooklynInvestmentStatus;
  isVisibleEditCancelRequestModal: boolean = false;
  listOfPrograms: any[] = [];
  listOfTags: any[] = [];
  isLoadingPrograms: boolean = false;
  enableDropdowns: boolean = false;
  showProgramDrawer: boolean = false;
  showTagsModal: boolean = false;
  isLoadingTags: boolean = false;
  canDeleteInvestmemnt: boolean = false;
  canDeletePayment: boolean = false;
  showInvoiceNumber: boolean = true;
  canAddTag: boolean = false;
  @Input() isFromActivity: boolean = true;
  @Input() showCancelButton: boolean = false;
  @Input() startingBalanceData: any;
  selectedTag: any;
  selectedTagName: string;
  selectedProgram: any;
  selectedTagFirst: any;
  selectedProgramFirst: any;
  selectedTagGroupFirst: any
  supplierId: string;
  isPaymentModal = 'invest';
  isCancelled: boolean = false;
  selectedTagGroup: string = '';
  selectedProgarmName: string = '';
  currentDefaultProgram: any;
  currentTransactionDetails: any;
  isUpdatingDetails: boolean = false;
  vendorQBDetails: any;
  activityTypeEnum = ActivityType;
  transactionTypeEnum = TransactionsType;
  brooklynInvestment: number = BrooklynInvestmentStatus.PendingApproval;
  selectedTagDebit: any;
  selectedProgramDebit: any;
  selectedTagGroupDebit: any;
  selectedTagNameDebit: string;
  selectedProgarmNameDebit: string;
  isVisibleDeleteModal: boolean = false;
  isDeleting: boolean = false;
  isFetchingDetails: boolean = false;
  subscription: Subscription[] = [];
  isLoadingQBOLink: boolean;
  filetype: any;
  qboOriginalbillLink: any;
  siteDetails: any;
  //#endregion

  //constructor
  constructor(
    private _cpS: CommonPagesService,
    private _route: ActivatedRoute,
    public _cS: CommonService,
    private _iS: InnerPagesService,
    private _router: Router,
    private sanitizer: DomSanitizer
  ) { }

  //#region functions
  ngOnInit(): void {
    this.isFetchingDetails = true;
    this.supplierId = this._route.snapshot.paramMap.get('supplierId');

    //load program periods of current site.
    this.subscription.push(
      this._cS.listOfTags.subscribe((res: any) => {
        if (res != null) {
          this.listOfTags = res;
        }
      }),
      this._cS.listOfProgramPeriods.subscribe((res: any) => {
        if (res != null) {
          this.listOfPrograms = res;
          const defaultProgram = this.listOfPrograms.find(
            (x: any) => x.isDefault
          );
          if (defaultProgram) {
            this.currentDefaultProgram = defaultProgram;
          }
        }
      }),
      this._cS.agencySiteDetails.subscribe((res: siteDetails) => {
        if (res) {
          this.siteDetails = res;
        }
      })
    );

    // get permission details of current user role of users
    this._cS.fetchDataAfterAutoLogin.subscribe(() => {
      this.canAddTag = this._iS.canAccessProgramsTags().canAddProgramTag;
      this.canDeleteInvestmemnt =
        this._iS.canAccessInvestments().canDeleteInvestment;
      this.canDeletePayment = this._iS.canAccessPayments().canDeletePayment;
      this._cS.programsListObserver.next('call');
      this.getTags();
    });
  }
  getTags() {
    this._iS.getTagsDropdownList(this.supplierId).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfTags = response.result;
        // this._cS.isLoadingTags = false;

        if (this.transactionType == TransactionsType.Payment) {
          this.getPaymentDetails();
        } else if (this.transactionType == TransactionsType.Investment) {
          this.getInvestmentDetails();
        } else if (this.transactionType == TransactionsType.Expenses) {
          this.getExpenseDetails();
        } else if (this.transactionType == TransactionsType.InternalTransfer) {
          this.getInternalTransferDetails();
        } else if (this.transactionType == TransactionsType.Refunds) {
          this.getRefundDetails();
        } else if (this.transactionType == TransactionsType.Credits) {
          this.getCreditDetails();
        } else if (this.transactionType == TransactionsType.Deposits) {
          this.getDepositDetails();
        } else if (this.transactionType == TransactionsType.StartingBalance) {
          this.getStartingBalanceDetails();
        } else {
          this.isFetchingDetails = false;
        }
      } else {
        this.listOfTags = [];
        this.isFetchingDetails = false;
        // this._cS.isLoadingTags = false;
      }
    });
  }
  getStartingBalanceDetails() {
    this._cpS
      .GetStartingBalanceDetails(this.transactionId)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.currentTransactionDetails = response.result;
          if (this.currentTransactionDetails.programId) {
            this.selectedProgram = this.currentTransactionDetails.programId;
            if (this.selectedProgram) {
              this.getProgramName(this.currentTransactionDetails.programId);
            }
          }
          this.isFetchingDetails = false;
        } else {
          this.isFetchingDetails = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  navigateToActivityPage() {
    this._router.navigate(['/supplier/' + this.supplierId + '/activity-detailed'], {
      queryParams: {
        filterTransactionType:
          this.showCancelButton == false
            ? ActivityType.CompletedTransactions
            : this.transactionType == TransactionsType.Investment
              ? ActivityType.OutstandingInvoice
              : null, // Provide a fallback value
      },
    });
  }

  parseStringToNumber(strData: string) {
    return Number(strData);
  }

  getInvestmentDetails() {
    const qboSupplierId = this._route.snapshot.queryParamMap.get('qbo') ? this._route.snapshot.queryParamMap.get('qbo') : this.siteDetails?.qboEntityId

    console.log('called', qboSupplierId);

    this._cpS
      .getInvestmentById(this.transactionId, qboSupplierId)
      .subscribe((response: any) => {
        if (
          response.responseStatus == ResponseStatus.success &&
          response.result != null
        ) {
          this.currentTransactionDetails = response.result;
          this.currentTransactionDetails.status = this.getStatus(
            this.currentTransactionDetails
          );
          this.currentTransactionDetails.createdOn = moment
            .utc(this.currentTransactionDetails.createdOn)
            .toDate();
          console.log('currentTransactionDetails', this.currentTransactionDetails);

          if (
            this.currentTransactionDetails.paybevInvestmentStatus ==
            PaybevInvestmentStatus.CancellationUnderReview ||
            this.currentTransactionDetails.brooklynInvestmentStatus ==
            BrooklynInvestmentStatus.UnderReview ||
            this.currentTransactionDetails.underReviewInfo
              ?.isMarkedAsUnderReview
          )
            this.isCancelled = true;

          // if (this.currentTransactionDetails?.brooklynInvestmentStatus == 1) {
          //   this.showInvoiceNumber = false;
          // }
          if (
            this.currentTransactionDetails.brooklynInvestmentStatus < 9 &&
            this.currentTransactionDetails.brooklynInvestmentStatus != 7
          ) {
            this.showCancelButton = true;
          }
          this.selectedProgram = this.currentTransactionDetails.program?.id;
          this.getProgramName(this.selectedProgram);
          this.isFetchingDetails = false;
        } else {
          this.isFetchingDetails = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }

  getPaymentDetails() {
    this._iS
      .getPaymentDetails(this.transactionId)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.currentTransactionDetails = response.result;
          this.currentTransactionDetails.createdOn = moment
            .utc(this.currentTransactionDetails.createdOn)
            .toDate();
          if (
            this.transactionType == this.transactionTypeEnum.Payment &&
            response.result != null
          )
            this.vendorQBDetails =
              this.currentTransactionDetails.vendorDetails?.quickBookVendorDetails;
          if (
            this.currentTransactionDetails.paybevPaymentStatus ==
            PaybevPaymentStatus.CancellationUnderReview ||
            this.currentTransactionDetails.brooklynBillStatus ==
            BrooklynBillStatus.UnderReview ||
            this.currentTransactionDetails.underReviewInfo
              ?.isMarkedAsUnderReview
          )
            this.isCancelled = true;
          this.selectedProgram = this.currentTransactionDetails.program?.id;
          this.selectedTag = this.currentTransactionDetails.tag?.id;
          this.getProgramName(this.selectedProgram);
          this.checkTagGroupData(this.selectedTag);
          // this.currentTransactionDetails.createdOn = this.getLocalDate(
          //   this.currentTransactionDetails.createdOn
          // );

          this.currentTransactionDetails.status = this.getStatus(
            this.currentTransactionDetails
          );
          if (this.currentTransactionDetails.brooklynBillStatus < 3) {
            this.showCancelButton = true;
          }
          this.isFetchingDetails = false;
        } else {
          this.isFetchingDetails = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  getExpenseDetails() {
    this._cpS.getExpense(this.transactionId).subscribe((response: any) => {
      if (
        response.responseStatus == ResponseStatus.success &&
        response.result != null
      ) {
        this.currentTransactionDetails = response.result;
        this.vendorQBDetails =
          this.currentTransactionDetails.vendorDetails?.quickBookVendorDetails;
        this.selectedProgram = this.currentTransactionDetails.program?.id;
        this.selectedTag = this.currentTransactionDetails.tag?.id;
        this.currentTransactionDetails['status'] = 'Completed';
        this.getProgramName(this.selectedProgram);
        this.checkTagGroupData(this.selectedTag);
        this.isFetchingDetails = false;
      } else {
        this.isFetchingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  getRefundDetails() {
    this._cpS.getRefund(this.transactionId).subscribe((response: any) => {
      if (
        response.responseStatus == ResponseStatus.success &&
        response.result != null
      ) {
        this.currentTransactionDetails = response.result;
        this.currentTransactionDetails['status'] = 'Completed';
        this.vendorQBDetails =
          this.currentTransactionDetails.vendorDetails?.quickBookVendorDetails;
        this.selectedProgram = this.currentTransactionDetails.program?.id;
        this.selectedTag = this.currentTransactionDetails.tag?.id;
        this.getProgramName(this.selectedProgram);
        this.checkTagGroupData(this.selectedTag);
        this.isFetchingDetails = false;
      } else {
        this.isFetchingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  getCreditDetails() {
    this._cpS.getCredit(this.transactionId).subscribe((response: any) => {
      if (
        response.responseStatus == ResponseStatus.success &&
        response.result != null
      ) {
        this.currentTransactionDetails = response.result;
        this.currentTransactionDetails['status'] = 'Completed';
        this.selectedProgram = this.currentTransactionDetails.program?.id;
        this.selectedTag = this.currentTransactionDetails.tag?.id;
        this.getProgramName(this.selectedProgram);
        this.checkTagGroupData(this.selectedTag);
        this.isFetchingDetails = false;
      } else {
        this.isFetchingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  getDepositDetails() {
    this._cpS.getDeposit(this.transactionId).subscribe((response: any) => {
      if (
        response.responseStatus == ResponseStatus.success &&
        response.result != null
      ) {
        this.currentTransactionDetails = response.result;
        this.currentTransactionDetails['status'] = 'Completed';
        this.vendorQBDetails =
          this.currentTransactionDetails.vendorDetails?.quickBookVendorDetails;
        this.selectedProgram = this.currentTransactionDetails.program?.id;
        this.selectedTag = this.currentTransactionDetails.tag?.id;
        this.getProgramName(this.selectedProgram);
        this.checkTagGroupData(this.selectedTag);
        this.isFetchingDetails = false;
      } else {
        this.isFetchingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }

  getInternalTransferDetails() {
    this._cpS
      .getInternalTransfer(this.transactionId)
      .subscribe((response: any) => {
        if (
          response.responseStatus == ResponseStatus.success &&
          response.result != null
        ) {
          this.setDetailsToIT(response.result);
        } else {
          this.isFetchingDetails = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  setDetailsToIT(data: any) {
    this.currentTransactionDetails = data;
    if (this.transactionDetails.transactionsSubType == 2) {
      this.selectedProgram =
        this.currentTransactionDetails.debitEntry.program?.id;
      this.selectedTag = this.currentTransactionDetails.debitEntry.tag?.id;
    } else {
      this.selectedProgram =
        this.currentTransactionDetails.creditEntry.program?.id;
      this.selectedTag = this.currentTransactionDetails.creditEntry.tag?.id;
    }
    if (this.selectedProgram) this.getProgramName(this.selectedProgram);
    if (this.selectedTag) this.checkTagGroupData(this.selectedTag);
    this.isFetchingDetails = false;
  }
  getProgramName(event: any) {
    const program = this.listOfPrograms.find((x: any) => x.id == event);
    this.selectedProgarmName = program?.label;
  }
  getProgramNameDebit(event: any) {
    const program = this.listOfPrograms.find((x: any) => x.id == event);
    this.selectedProgarmNameDebit = program?.label;
  }
  showCancelRequestModal() {
    if (
      this.currentTransactionDetails?.brooklynBillStatus == 1 ||
      this.currentTransactionDetails?.brooklynInvestmentStatus == 1
    ) {
      this.isVisibleDeleteModal = true;
    } else {
      this.isVisibleEditCancelRequestModal = true;
    }
  }
  sendUnderReviewNotification: boolean = false;
  hideCancelPaymentModal(event: any) {
    this.isVisibleEditCancelRequestModal = false;
    if (event.transactionId) {
      this.sendUnderReviewNotification = true;
      this.isCancelled = true;
      if (event.transactionsType == this.transactionTypeEnum.Payment) {
        this.currentTransactionDetails.paybevPaymentStatus = 2;
      } else {
        this.currentTransactionDetails.paybevInvestmentStatus = 6;
      }

      if (event.isEdit) {
        this.currentTransactionDetails.underReviewInfo = {
          isMarkedAsUnderReview: true,
          reason: 'Edit Request By User',
          color: 'gray',
        };
      } else {
        this.currentTransactionDetails.underReviewInfo = {
          isMarkedAsUnderReview: true,
          reason: 'Cancel Request By User',
          color: 'gray',
        };
      }
      this.hideTransactionModal.emit({
        hide: true,
        data: this.currentTransactionDetails,
      });
    }
  }

  manageProgramPeriod() {
    this.showProgramDrawer = true;
  }
  manageTags() {
    this.showTagsModal = true;
  }
  handleCancelProgram() {
    this.showProgramDrawer = false;
  }
  newAddedProgram(event: any) {
    if (event.data) {
      if (event.data.isDefault) {
        this.selectedProgram = event.data.id;
        this.selectedProgramDebit = event.data.id;
        this.listOfPrograms.map((x: any) => (x.isDefault = false));
        event.data.isDefault = true;
      } else if (event.data.isVisible) {
        this.listOfPrograms?.splice(0, 0, event.data);
      } else {
        this.listOfPrograms = this.listOfPrograms.filter(
          (x: any) => x.id !== event.data.id
        );
      }
    }
  }

  addUpdateProgram(event: any) {
    if (event.isNewData) {
      if (event.data.isVisible) {
        this.listOfPrograms?.splice(0, 0, event.data);
      }
    } else {
      // const existingData = this.listOfPrograms.find(
      //   (x: any) => x.id == event.data.id
      // );
      const existingIndex = this.listOfPrograms.findIndex(
        (x: any) => x.id == event.data.id
      );
      // if (this.selectedProgram == existingData.id) {
      this.listOfPrograms[existingIndex].label = event.data.label;
      // }
    }
  }

  checkTagGroupData(event: any) {
    if (event) {
      let selectedGroup: any;
      let findSelectedTag: any;
      this.listOfTags.forEach((element: any) => {
        element.Tags.forEach((tag: any) => {
          if (tag._id == event) {
            findSelectedTag = tag;
            selectedGroup = element;
          }
        });
      });
      this.selectedTagGroup = selectedGroup;
      this.selectedTagName = findSelectedTag?.Name;
    }
  }
  checkTagGroupDataDebit(event: any) {
    let selectedGroup: any;
    let findSelectedTag: any;
    this.listOfTags.forEach((element: any) => {
      element.Tags.forEach((tag: any) => {
        if (tag._id == event) {
          findSelectedTag = tag;
          selectedGroup = element;
        }
      });
    });
    this.selectedTagGroupDebit = selectedGroup;
    this.selectedTagNameDebit = findSelectedTag?.Name;
  }
  printTransaction() {
    window.print();
  }
  handleCancelTags() {
    this.showTagsModal = false;
  }
  handleCancel(data?: any) {
    this.isVisibleDeleteModal = false;
    if (data || this.sendUnderReviewNotification) {
      this.hideTransactionModal.emit({
        hide: this.isVisibleDeleteModal,
        data: this.currentTransactionDetails,
      });
    }
  }
  deleteTransaction() {
    this.isDeleting = true;
    if (this.currentTransactionDetails.brooklynBillStatus) {
      this._cpS
        .deletePayment(this.currentTransactionDetails.id)
        .subscribe((response: any) => {
          if (response.responseStatus == 1) {
            this.isVisibleDeleteModal = false;
            this.isDeleting = false;
            this.handleCancel('data');
            this._cS.displayMessage('success', response.message);
          } else {
            this._cS.displayMessage('error', response.message);
            this.isVisibleDeleteModal = false;
            this.isDeleting = false;
          }
        });
    } else if (this.currentTransactionDetails.brooklynInvestmentStatus) {
      const formData = new FormData();
      formData.set('InvestmentId', this.currentTransactionDetails.id);
      this._cpS.deleteInvestment(formData).subscribe((response: any) => {
        if (response.responseStatus == 1) {
          this.isVisibleDeleteModal = false;
          this.isDeleting = false;
          this._cS.displayMessage('success', response.message);
          this.handleCancel('data');
        } else {
          this._cS.displayMessage('error', response.message);
          this.isDeleting = false;
          this.isVisibleDeleteModal = false;
        }
      });
    }
  }
  manageTrDeatails() {
    this.enableDropdowns = true;
    this.selectedTagFirst = this.selectedTag;
    this.selectedTagGroupFirst = this.selectedTagGroup;
    this.selectedProgramFirst = this.selectedProgram;
  }
  saveTrDetails() {
    this.isUpdatingDetails = true;
    if (this.transactionType == TransactionsType.Payment) {
      this.updatePayment();
    } else if (this.transactionType == TransactionsType.Investment) {
      this.updateInvestment();
    } else if (this.transactionType == TransactionsType.Expenses) {
      this.updateExpense();
    } else if (this.transactionType == TransactionsType.InternalTransfer) {
      this.updateInternalTransfer();
    } else if (this.transactionType == TransactionsType.StartingBalance) {
      this.updateStartingBalance();
    } else if (this.transactionType == TransactionsType.Credits) {
      this.updateCredit();
    } else if (this.transactionType == TransactionsType.Refunds) {
      this.updateRefund();
    } else if (this.transactionType == TransactionsType.Deposits) {
      this.updateDeposit();
    }
  }
  updateStartingBalance() {
    const formData = new FormData();
    formData.set('TransId', this.currentTransactionDetails.transactionsId);
    formData.set('ProgramId', this.selectedProgram);
    this._cpS
      .UpdateProgramToStartingBalTransaction(formData)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isUpdatingDetails = false;
          this.enableDropdowns = false;
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
          this.isUpdatingDetails = false;
        }
      });
  }
  updateExpense() {
    const requestBody = {
      expenseId: this.currentTransactionDetails.id,
      program: {
        id: this.selectedProgram,
        name: this.selectedProgarmName,
      },
      tag: {
        id: this.selectedTag,
        name: this.selectedTagName,
        transcationids: this.currentTransactionDetails.tag?.count,
      },
      isNonAlc: this.currentTransactionDetails.isNonAlc,
    };
    this._cpS.updateExpense(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isUpdatingDetails = false;
        this.enableDropdowns = false;
        this.selectedProgram = response.result.program.id;
        this.selectedTag = response.result.tag.id;
        this.getProgramName(this.selectedProgram);
        this.checkTagGroupData(this.selectedTag);
        this._cS.displayMessage(
          responseMessageStatus.success,
          response.message
        );
      } else {
        this.isUpdatingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  updateInternalTransfer() {
    const requestBody = {
      transferId: this.currentTransactionDetails.id,
      creditEntry: {
        program:
          Number(this.transactionDetails.transactionsSubType) == 1
            ? {
              id: this.selectedProgram,
              name: this.selectedProgarmName,
            }
            : this.currentTransactionDetails.creditEntry.program,
        tag:
          Number(this.transactionDetails.transactionsSubType) == 1
            ? {
              id: this.selectedTag,
              name: this.selectedTagName,
              transcationids: this.currentTransactionDetails.creditEntry.tag
                ? this.currentTransactionDetails.creditEntry.tag
                  .transcationids
                : null,
            }
            : this.currentTransactionDetails.creditEntry.tag,
        isNonAlc: this.currentTransactionDetails.creditEntry.isNonAlc,
      },
      debitEntry: {
        program:
          Number(this.transactionDetails.transactionsSubType) == 2
            ? {
              id: this.selectedProgram,
              name: this.selectedProgarmName,
            }
            : this.currentTransactionDetails.debitEntry.program,
        tag:
          Number(this.transactionDetails.transactionsSubType) == 2
            ? {
              id: this.selectedTag,
              name: this.selectedTagName,
              transcationids: this.currentTransactionDetails.debitEntry.tag
                ? this.currentTransactionDetails.debitEntry.tag.transcationids
                : null,
            }
            : this.currentTransactionDetails.debitEntry.tag,
        isNonAlc: this.currentTransactionDetails.debitEntry.isNonAlc,
      },
    };

    this._cpS.updateInternalTransfer(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isUpdatingDetails = false;
        this.enableDropdowns = false;
        this.setDetailsToIT(response.result);
        this._cS.displayMessage(
          responseMessageStatus.success,
          response.message
        );
      } else {
        this.isUpdatingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  updatePayment() {
    this.currentTransactionDetails.program = {
      id: this.selectedProgram,
      name: this.selectedProgarmName,
    };
    this.currentTransactionDetails.tag = {
      id: this.selectedTag,
      name: this.selectedTagName,
    };
    this._cpS
      .updatePaymentDetails(this.currentTransactionDetails)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isUpdatingDetails = false;
          this.enableDropdowns = false;
          this.selectedProgram = response.result.program.id;
          this.selectedTag = response.result.tag.id;
          this.getProgramName(this.selectedProgram);
          this.checkTagGroupData(this.selectedTag);
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this.isUpdatingDetails = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  updateCredit() {
    this.currentTransactionDetails.program = {
      id: this.selectedProgram,
      name: this.selectedProgarmName,
    };
    this.currentTransactionDetails.tag = {
      id: this.selectedTag,
      name: this.selectedTagName,
    };
    const requestBody = {
      id: this.currentTransactionDetails.id,
      program: this.currentTransactionDetails.program,
      tag: this.currentTransactionDetails.tag,
      isNonAlc: this.currentTransactionDetails.isNonAlc,
    };
    this._cpS.updateCredit(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isUpdatingDetails = false;
        this.enableDropdowns = false;
        this.selectedProgram = response.result.program.id;
        this.selectedTag = response.result.tag.id;
        this.getProgramName(this.selectedProgram);
        this.checkTagGroupData(this.selectedTag);
        this._cS.displayMessage(
          responseMessageStatus.success,
          response.message
        );
      } else {
        this.isUpdatingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  updateRefund() {
    this.currentTransactionDetails.program = {
      id: this.selectedProgram,
      name: this.selectedProgarmName,
    };
    this.currentTransactionDetails.tag = {
      id: this.selectedTag,
      name: this.selectedTagName,
    };
    this._cpS
      .updateRefund(this.currentTransactionDetails)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isUpdatingDetails = false;
          this.enableDropdowns = false;
          this.selectedProgram = response.result.program.id;
          this.getProgramName(this.selectedProgram);
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this.isUpdatingDetails = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  updateDeposit() {
    this.currentTransactionDetails.program = {
      id: this.selectedProgram,
      name: this.selectedProgarmName,
    };
    this.currentTransactionDetails.tag = {
      id: this.selectedTag,
      name: this.selectedTagName,
    };
    this._cpS
      .updateDeposit(this.currentTransactionDetails)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isUpdatingDetails = false;
          this.enableDropdowns = false;
          this.selectedProgram = response.result.program.id;
          this.selectedTag = response.result.tag.id;
          this.getProgramName(this.selectedProgram);
          this.checkTagGroupData(this.selectedTag);
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this.isUpdatingDetails = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  patchTagToForm(event: any) {
    this.showTagsModal = false;
    this._cS.tagsObserver.next('call');
    setTimeout(() => {
      const tagGroup = this.listOfTags.find((x: any) => x._id == event.newTag);
      const newCreatedTag = tagGroup.Tags[tagGroup.Tags.length - 1];
      this.selectedTagGroup = tagGroup;
      if (newCreatedTag) {
        this.selectedTag = this.selectedTagDebit = newCreatedTag._id;
      }
    }, 2000);
  }

  updateInvestment() {
    const requestBody = this.currentTransactionDetails;
    requestBody.program = {
      id: this.selectedProgram,
      name: this.selectedProgarmName,
    };
    this._cpS.SaveInvestment(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isUpdatingDetails = false;
        this.enableDropdowns = false;
        this.selectedProgram = response.result.program.id;
        this.getProgramName(this.selectedProgram);
        this._cS.displayMessage(
          responseMessageStatus.success,
          response.message
        );
      } else {
        this.isUpdatingDetails = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  undoChanges() {
    this.enableDropdowns = false;
    this.selectedProgram = this.selectedProgramFirst;
    this.selectedTag = this.selectedTagFirst;
    this.selectedTagGroup = this.selectedTagGroupFirst;
  }

  getStatus(data: any) {
    const activityStatus =
      this.transactionType == TransactionsType.Payment
        ? data.brooklynBillStatus
        : data.brooklynInvestmentStatus;
    let status: any;
    const arrayToSearch: any =
      this.transactionType == TransactionsType.Payment
        ? this._cS.paymentStatus
        : this._cS.investmentStatus;
    arrayToSearch.every((element: any) => {
      if (element.statusEnum == activityStatus) {
        status = element.statusText;
        return false;
      }
      return true;
    });
    return status;
  }
  openPublicInvoice(invoiceLink: any) {
    window.open(invoiceLink, '_blank');
  }
  getLocalDate(UTCdate: any) {
    return moment.utc(UTCdate).toDate();
  }
  // to remove error : Error: unsafe value used in a resource URL context
  getSafeUrl(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  fetchAttachmentURL(qboAttachmentId: any) {
    this.isLoadingQBOLink = true;
    if (qboAttachmentId != null && qboAttachmentId != 'null') {
      this._cpS
        .PreviewQBOAttachment(qboAttachmentId)
        .subscribe((response: any) => {
          if (response.responseStatus == 1) {
            this.qboOriginalbillLink = response.result.tempDownloadUri;
            this.filetype = response.result.contentType;
            if (this.filetype.includes('image')) {
              this.qboOriginalbillLink = this.getSafeUrl(
                response.result.tempDownloadUri
              );
            }

            window.open(this.qboOriginalbillLink, '_blank');
            this.isLoadingQBOLink = false;
          } else {
            this._cS.displayMessage('error', response.message);
            this.isLoadingQBOLink = false;
          }
        });
    }
  }
  ngOnDestroy(): void {
    this.subscription.map((s) => s.unsubscribe());
  }
  //#endregion
}
